import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Skeleton, Text } from '@chakra-ui/react';

import Breadcrumb from '../components/layout/Breadcrumb';
import OrderCard, { orderState } from '../components/OrderCard';
import { useUserContext } from '../contexts/UserContext';
import { getOrdersByUserId } from '../services/OrderServices';

const condensed = { fontWeight: 700, textTransform: 'uppercase', sx: { fontStretch: '75%' } };

// My orders: Active / All tabs and one card per order, newest first
const Orders = () => {

  const navigate = useNavigate();
  const { currentUser } = useUserContext();
  const [tab, setTab] = useState('active');
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    getOrdersByUserId(currentUser)
      .then((result) => setOrders([...(result.orders || [])].sort((a, b) => new Date(b.orderDate) - new Date(a.orderDate))))
      .catch(() => setOrders([]));
  }, [currentUser]);

  const shown = (orders || []).filter(o => tab === 'all' || ['preparing', 'onWay'].includes(orderState(o)));

  return (
    <Box>
      <Breadcrumb items={[{ label: 'Home', to: '/' }, { label: 'My orders' }]} />
      <Box maxWidth='820px' mx='auto' px={{ base: '12px', md: '24px' }} pt={{ base: '20px', md: '32px' }} pb={{ base: '32px', md: '56px' }} >
        <Text as='h1' fontSize={{ base: '28px', md: '36px' }} {...condensed} >My orders</Text>
        <Box role='tablist' display='flex' gap='8px' mt='16px' mb='20px' >
          {[['active', 'Active'], ['all', 'All orders']].map(([key, label]) => (
            <Box key={key} as='button' role='tab' aria-selected={tab === key} height='36px' px='16px' borderRadius='full' border='1px solid' fontSize='14px'
              borderColor={tab === key ? 'raano.black' : 'raano.border'} bg={tab === key ? 'raano.black' : 'raano.white'} color={tab === key ? 'raano.white' : 'raano.black'} onClick={() => setTab(key)} >{label}</Box>
          ))}
        </Box>

        {orders === null
          ? [0, 1].map(i => <Skeleton key={i} height='180px' mb='14px' borderRadius='8px' />)
          : shown.length
            ? shown.map(o => <OrderCard key={o._id} order={o} />)
            : (
              <Box textAlign='center' py='48px' >
                <Text fontSize='22px' {...condensed} >{tab === 'active' ? 'No active orders' : 'No orders yet'}</Text>
                <Text mt='6px' fontSize='14px' color='raano.muted' >Find something you'll wear on repeat.</Text>
                <Button mt='20px' variant='ink' height='48px' px='40px' fontSize='16px' onClick={() => navigate('/search', { state: {} })} >Shop all</Button>
              </Box>
            )}
      </Box>
    </Box>
  );
};

export default Orders;
